"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RiskObjectLabel = function RiskObjectLabel(_ref) {
  var amount = _ref.amount,
      icon = _ref.icon,
      otherProps = _objectWithoutProperties(_ref, ["amount", "icon"]);

  var IconToRender;

  if (icon !== '') {
    IconToRender = /*#__PURE__*/_react.default.createElement(RiskObjectLabelIcon, null, icon);
  }

  return /*#__PURE__*/_react.default.createElement(RiskObjectLabelWrapper, otherProps, IconToRender, /*#__PURE__*/_react.default.createElement(RiskObjectLabelBadge, null, amount));
};

var RiskObjectLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectLabelWrapper"
})(["display:flex;justify-content:flex-start;align-items:center;font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var RiskObjectLabelIcon = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectLabelIcon"
})(["margin-right:0.3rem;svg{transform:scale(0.7);transform-origin:center center;}"]);

var RiskObjectLabelBadge = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectLabelBadge"
})(["min-width:20px;padding-left:5px;padding-right:5px;height:20px;border-radius:999px;color:", ";font-family:", ";display:flex;justify-content:center;align-items:center;background-color:", ";font-weight:500;font-size:14px;line-height:120%;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.lightest;
});

RiskObjectLabel.defaultProps = {
  amount: 0,
  icon: 'IconCarFilled',
  iconColor: '#505050',
  otherProps: {}
};
RiskObjectLabel.propTypes = {
  /** The amount to be displayed inside the badge */
  amount: _propTypes.number,

  /** The name of the icon to be displayed */
  icon: _propTypes.node,

  /** The color of the icon */
  iconColor: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = RiskObjectLabel;
exports.default = _default;